import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { FC, useCallback } from 'react';
import DropDownWithSearch from 'src/components/DropDownWithSearch';
import usePeriodView from 'src/hooks/usePeriodView';
import { SetState } from 'src/types/generic';
import { PropertyObject } from './Export';

interface PropertyDropdownProps {
  propertyList: PropertyObject[];
  property: PropertyObject;
  setProperty: SetState<PropertyObject>;
  disabled: boolean;
  loading: boolean;
}
const PropertyDropdown: FC<PropertyDropdownProps> = ({
  propertyList,
  property,
  setProperty,
  disabled,
  loading,
}) => {
  const { t } = usePeriodView();
  const handleManagementCompanyChange = useCallback(
    (event: DropDownListChangeEvent) => {
      setProperty(event.value);
    },
    [setProperty]
  );

  return (
    <div className="mb-2">
      <label className="text-xs font-bold">{t('Property')}</label>
      <DropDownWithSearch
        id="view-drop-down-list"
        style={{ width: '100%' }}
        options={propertyList}
        textField="companyName"
        dataItemKey="companyId"
        value={property}
        onChange={handleManagementCompanyChange}
        loading={loading}
        disabled={loading || disabled}
      />
    </div>
  );
};

export default PropertyDropdown;
